"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types");
function sandboxMeetingStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_CREATE_SANDBOX_MEETING, "_FAILURE")) {
    state = {
      error: true
    };
  }
  if (action.type === "".concat(_types.BROADCAST_CREATE_SANDBOX_MEETING, "_SUCCESS")) {
    state = {
      error: false
    };
  }
  return state;
}
var _default = exports["default"] = sandboxMeetingStatus;